import React from "react"
import Heading from "./Heading"
import List, { ListItem } from "./List"
import Paragraph from "./Paragraph"
import Loading from "./Loading"

const HtmlBuilder = ({ elements }) => {

  const renderComponent = (item) => {
    switch (item.type) {
      case "Paragraph":
        let replace = []
        if (item.replacements) {
          replace = item.replacements
        }

        return <Paragraph
          key={item.key}
          text={item.text}
          replace={replace}
          className={item.className}
          bold={false} />

      case "BoldParagraph":
        let replace2 = []
        if (item.replacements) {
          replace2 = item.replacements
        }

        return <Paragraph
          key={item.key}
          text={item.text}
          replace={replace2}
          className={item.className}
          bold={true} />

      case "Heading":
        return <Heading key={item.key} level={item.level} className={item.className}>
          {item.text}
        </Heading>

      case "List":
        return <List key={item.key} className={item.className}>
          {item.list.map((item, i) => (
            <ListItem key={i} >{item}</ListItem>
          ))}
        </List>

      case 'link':
        var extDoc = [".doc", ".docx", ".xls", ".xlsx", ".xlsm", ".ppt", ".pptx", ".exe", ".zip", ".pdf", ".txt", ".rss", ".mobi", ".epub", ".mp3", ".wmv", ".asx", ".smi", ".js"];
        if (new RegExp(extDoc.join("|")).test(item.href)) {
          return <a
            key={item.key}
            name="downloadables"
            href={item.href}
          // onClick={handleClick.bind(this,item.href)}
          >{item.text}</a>
        } else {
          return <a
            key={item.key}
            href={item.href}
          >{item.text}</a>
        }

      case '"Action': //NEED TO ASK CLAY ABOUT THIS - MP
        return <a key={item.key} href="/test#" onClick={item.onClick} >{item.text}</a>

      case 'Loading':
        return <Loading />

      default:
        return null;
    }
  },
    values = typeof elements === "undefined" ? [] : Object.values(elements)

  return (
    <>
      { values.map((item) => (
        renderComponent(item)
      ))}
    </>
  )
}

export default HtmlBuilder
